import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const MinStyleUl = styled('ul')({listStyle: 'none', paddingLeft: 0, margin: 0});
/**
 * MUI-based component for rendering a minimalistic list of texts without frills, padding, margins or bullet-points.
 * @return  {node}
 */
const MinimaList = ({lines}) => <MinStyleUl>{
    lines.map((line, index) => <li key={index}><Typography>{line}</Typography></li>)
}</MinStyleUl>;
MinimaList.propTypes = {
    lines: PropTypes.arrayOf(
        PropTypes.string.isRequired
    ).isRequired
};

export default MinimaList;
